var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{style:(_vm.customStyle),attrs:{"clearable":"","value":_vm.selectedCity,"filterable":"","placeholder":"请选择城市","disabled":_vm.disabled},on:{"change":_vm.changeCity}},_vm._l((_vm.city_options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }